import { toast } from "react-toastify";
import api from "./api/api";

const ServiceRepresentantes = {
  listRepresentantes: async (page: any, perPage: any, search?: any) => {
    try {
      if (search) {
        const res = await api.get(
          `/representantes?page=${page}&perPage=${perPage}&s=${search}`
        );
        return res;
      } else {
        const res = await api.get(
          `/representantes?page=${page}&perPage=${perPage}`
        );
        return res;
      }
    } catch (error: any) {
      return error.response;
    }
  },
  adicionarRepresentantes: async (payload: any) => {
    try {
      const res = await api.post("/representantes", payload);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  editarRepresentantes: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/representantes/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  deleteRepresentantes: async (id: any) => {
    try {
      const res = await api.delete(`/representantes/${id}`);
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  relacionamentoAgencyRep: async (payload: any, representante_id: any) => {
    try {
      const res = await api.post(
        `/representantes/relacionamento/${representante_id}`,
        payload
      );
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
};

export default ServiceRepresentantes;
